"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const storyCreateStates_1 = require("./storyCreateStates");
const react_i18next_1 = require("react-i18next");
const RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isUpdate = window.location.pathname.includes('update');
    const [{ auth_status }, setStoryData] = (0, recoil_1.useRecoilState)(storyCreateStates_1.storyDataState);
    const AuthTypeAllFCL = () => ((0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: { marginLeft: '-4px' }, value: 0, control: (0, jsx_runtime_1.jsx)(Radio_1.default, { color: "secondary" }), label: (0, jsx_runtime_1.jsx)("h4", { children: t('익명, 로그인 모두') }) }));
    const AuthTypeLoginFCL = () => ((0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: { marginLeft: '-4px', marginTop: '14px' }, value: 1, control: (0, jsx_runtime_1.jsx)(Radio_1.default, { color: "secondary" }), label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { children: t('로그인만') }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { position: 'relative', display: 'flex', alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)("div", { css: {
                                position: 'absolute',
                                left: '2px',
                                width: '6px',
                                height: '6px',
                                backgroundColor: '#f8f8f8',
                                transform: 'rotate(-45deg)',
                            } }), (0, jsx_runtime_1.jsx)("h5", { children: t('차단 가능') })] }))] }) }));
    return ((0, jsx_runtime_1.jsxs)(AuthTypeWrapper, { children: [(0, jsx_runtime_1.jsx)("h2", { children: t('누구나 참여할 수 있나요?') }), (0, jsx_runtime_1.jsxs)(RadioGroup_1.default, Object.assign({ value: auth_status, onChange: e => setStoryData(prev => (Object.assign(Object.assign({}, prev), { auth_status: Number(e.target.value) }))) }, { children: [!isUpdate ? (0, jsx_runtime_1.jsx)(AuthTypeAllFCL, {}) : auth_status == 0 && (0, jsx_runtime_1.jsx)(AuthTypeAllFCL, {}), !isUpdate && auth_status == 0 && ((0, jsx_runtime_1.jsxs)(NoticeWrapper, { children: [(0, jsx_runtime_1.jsxs)("span", { children: [" \u00B7 ", t('등록 후 수정 불가'), " "] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', columnGap: 3, alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: " \u00B7 " }), (0, jsx_runtime_1.jsx)("h6", { children: t('참여자 기록이 없어요') })] }))] })), !isUpdate ? (0, jsx_runtime_1.jsx)(AuthTypeLoginFCL, {}) : auth_status == 1 && (0, jsx_runtime_1.jsx)(AuthTypeLoginFCL, {}), !isUpdate && auth_status == 1 && ((0, jsx_runtime_1.jsx)(NoticeWrapper, { children: (0, jsx_runtime_1.jsxs)("span", { children: [" \u00B7 ", t('등록 후 수정불가'), " "] }) }))] }))] }));
}
exports.default = default_1;
const AuthTypeWrapper = styled_1.default.div `
  padding: 20px;
  margin-bottom: 10px;
  background-color: white;
  h2 {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 17px;
  }
  h4 {
    margin: 0 4px;
    font-weight: 400;
    font-size: 17px;
  }
  h5 {
    padding: 5px 8px;
    border-radius: 100px;
    margin-left: 4px;
    background: #f8f8f8;
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.7);
  }
  .MuiFormControlLabel-label {
    position: relative;
    display: flex;
    align-items: center;
  }
`;
const NoticeWrapper = styled_1.default.div `
  padding-top: 2px;
  margin-left: 5px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.2px;
  span {
    color: #eb5757;
    font-weight: 700;
  }
  h6 {
    color: #eb5757;
    line-height: 18px;
  }
`;
